import * as React from "react";
import { Tree } from "antd";
import { TreeProps } from "antd/lib/tree";
import { DataNode } from "antd/lib/tree";

export interface TreeDataNode extends DataNode {}

function updateTreeData(list: TreeDataNode[], key: React.Key, children: TreeDataNode[]): TreeDataNode[] {
  return list.map((node) => {
    if (node.key === key) {
      return {
        ...node,
        children,
      };
    } else if (node.children) {
      return {
        ...node,
        children: updateTreeData(node.children, key, children),
      };
    }
    return node;
  });
}

interface NewAsyncTreeProps extends Omit<TreeProps, "loadData" | "initialData"> {
  loadData: (key: string | number) => Promise<TreeDataNode[]>;
  initialData?: TreeDataNode[];
}

export const NewAsyncTree = ({ loadData, initialData = [], ...treeProps }: NewAsyncTreeProps) => {
  const [treeData, setTreeData] = React.useState(initialData);

  async function onLoadData({ key, children }: TreeDataNode): Promise<void> {
    try {
      if (children) {
        return;
      }
      const response = await loadData(key as string);
      setTreeData((origin) => updateTreeData(origin, key, response));
      return;
    } catch (error) {
      throw error;
    }
  }

  return <Tree loadData={onLoadData} treeData={treeData} {...treeProps} />;
};
